<template lang="pug">
div.padding.p-b-0.p-t-sm
    .alert.info
        i.material-icons info 
        |   End product quantity is a dynamically calculated value that automatically keeps track of the quantity by its components.
    div.box
        v-server-table(
            :url="api",
            :name="tableName",
            ref="datatable",
            :columns="columns",
            :options="options"
        )
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Vue from 'vue';
import stockModule from '@js/store/modules/stock';

const exportUrl = 'stocks.composites.export';

export default {
    data() {
        return {
            tableName: 'VUETABLE_COMPOSITE',
            columns: ['name', 'sku', 'price', 'quantity', 'components'],
            options: {
                useReportFilter: true,
                texts: {
                    title: 'End Product',
                    description: 'List of End Product items',
                },
                sortable: ['name', 'sku', 'price', 'quantity'],
                pdf_url: Laroute.route(exportUrl, { type: 'PDF' }),
                csv_url: Laroute.route(exportUrl, { type: 'CSV' }),
                xls_url: Laroute.route(exportUrl, { type: 'XLSX' }),
                templates: {
                    quantity: (h, row) => {
                        return require('./composite-quantity.jsx')(
                            h,
                            row,
                            this.activeOutlet,
                        );
                    },
                    components(h, row) {
                        return require('./composite-components.jsx')(h, row);
                    },
                },
                columnsClasses: {
                    quantity: 'text-center',
                },
            },
        };
    },

    computed: {
        ...mapGetters(['activeOutlet']),

        api() {
            return Laroute.route('stocks.composites.index');
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/stock/stock-composite-list.vue